import { Component, OnInit } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { NgProgressRef, NgProgress } from 'ngx-progressbar';
import { Subscription } from 'rxjs';
import { PaginationInput, PaginationPageEvent, ListParams, Res, NotificationData } from 'src/app/models';
import { LanguageService, ApiNotificationsService } from 'src/app/services';

@Component({
  selector: 'app-notification-profile',
  templateUrl: './notification-profile.component.html',
  styleUrls: ['./notification-profile.component.css']
})
export class NotificationProfileComponent implements OnInit {

  progressRef: NgProgressRef;
  subscriptions: Subscription = new Subscription();
  language: string;
  loading: boolean;
  notification: NotificationData;
  notificationId: string;

  paginationInput: PaginationInput;
  paginationOutput: PaginationPageEvent;
  listParams: ListParams;

  constructor(
    public ngProgress: NgProgress,
    private languageService: LanguageService,
    private currentRoute: ActivatedRoute,
    private apiNotifications: ApiNotificationsService,
    private router: Router,
    private sanitizer: DomSanitizer
  ) { }

  ngOnInit(): void {

    this.progressRef = this.ngProgress.ref('progress-bar');
    this.notificationId = this.currentRoute.snapshot.paramMap.get('id');

    this.getInfo();
    // this.changeState();

    this.subscriptions.add(
      this.languageService.listenerLanguage().subscribe(val => {

        this.language = val.language;
      })
    );

    this.router.events.subscribe(event => {
      if (event instanceof NavigationEnd) {

        this.notificationId = this.currentRoute.snapshot.paramMap.get('id');
        this.getInfo();
        // this.changeState();
      }
    });
  }

  ngOnDestroy(): void {

    this.subscriptions.unsubscribe();
  }


  /**
   * 
   */
  getInfo(): void {

    this.progressRef.start();
    this.loading = true;
    this.notification = null;

    this.apiNotifications.editNotifications(this.notificationId).subscribe((response: Res) => { console.log("[RESPONSE] editNotifications: ", response);

      if (response != null) {

        response.result.message = this.sanitizer.bypassSecurityTrustHtml(response.result.message) as SafeHtml;

        this.notification = response.result.message;

        this.apiNotifications.actionNotificationRead(true);
        // this.notification.notification_content = JSON.parse(this.notification.notification_content);
      }

      this.progressRef.complete();
      this.loading = false;
    },
    error => {
      this.progressRef.complete();
      this.loading = false;
    });
  }


  /**
   * 
   */
  changeState(): void {

    this.progressRef.start();

    this.apiNotifications.changeState({ id: this.notificationId }).subscribe((response: Res) => { console.log("[RESPONSE] changeState: ", response);

      if (response != null) {
        
        this.apiNotifications.notificationReadSubject.next(true);
      }

      this.progressRef.complete();
      this.loading = false;
    },
    error => {
      this.progressRef.complete();
      this.loading = false;
    });
  }
}
